<template>
  <div class="home-container">
    <iframe
      v-show="ready"
      ref="iframe"
      class="home-page"
      src="https://www.oneclass.com.tw/"
      @load="onload"
      frameborder="0">
    </iframe>

    <v-progress-circular
      v-show="!ready && !appLoading"
      class="home-loading"
      :size="70"
      :width="7"
      color="accent"
      indeterminate />
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  data() {
    return {
      ready: false
    };
  },

  computed: {
    ...mapState({
      appLoading: state => state.appLoading
    })
  },

  watch: {
    '$route'() {
      if (this.$route.name === 'Home') {
        this.ready = false;
      }
    }
  },

  methods: {
    onload() {
      this.ready = true;
    }
  }
};
</script>


<style lang="stylus" scoped>

.home-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // background-image: radial-gradient(#f9f9f9, #cbd3db);
  // background-attachment: fixed;
  // background-size: cover;
}

.home-page {
  width: 100%;
  height: 100%;
}

.home-loading {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

</style>

